const mockCourses = [
  {
    id: 1,
    title: "HTML e CSS basico",
    type: "video",
    thumbnail:
      "https://i.ytimg.com/vi/Fhy-5CtVkiM/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAbvnsvWv1L6oUsB3JFWDEtLup8BA",
    link: "https://www.youtube.com/watch?v=Fhy-5CtVkiM",
    description: "Curso completo de HTML + CSS apresentado por uma bela moça.",
    progress: 35,
  },
  {
    id: 2,
    title: "Introducão a programacao",
    type: "texto",
    thumbnail:
      "https://i0.wp.com/garonpower.com/wp-content/uploads/2019/01/computer-programming.jpeg?fit=1500%2C1000&ssl=1",
    link: "https://www.w3schools.com/programming/",
    description:
      "Material com principais tags e estrutura de página. Site muito utilizado por iniciantes",
    progress: 70,
  },
  {
    id: 3,
    title: "Hacking ético ",
    type: "imagem",
    thumbnail:
      "https://www.varonis.com/hubfs/Varonis_June2021/Images/whitehat_1-650x365.png",
    link: "https://www.3way.com.br/wp-content/uploads/2017/01/eH.png",
    description: "Fases de Pentest",
    progress: 10,
  },
  {
    id: 4,
    title: "Guia Rápido de Ferramentas",
    type: "link",
    thumbnail:
      "https://softdesign.com.br/wp-content/uploads/2024/11/ferramentas-de-desenvolvimento-e-gerenciamento.webp",
    link: "https://softdesign.com.br/blog/as-melhores-ferramentas-de-desenvolvimento-de-software-para-impulsionar-a-produtividade-na-sua-empresa/",
    description:
      "Links úteis e recursos extras. Ferramentas para aumentar a produtividade dos devs",
    progress: 0,
  },
];

export default mockCourses;
